export default "__VITE_ASSET__BEUAAPA___"